import { SearchableSelect } from '@/components/common';

interface InsuranceTypeStepProps {
  value: string;
  onChange: (code: string) => void;
  options: { value: string; label: string }[];
  loading?: boolean;
}

/**
 * Step 1 for every branch (motor/life/health). The active insurance type is
 * driven by `?type=` on load; this step lets the user confirm or switch it,
 * which swaps the container's active step list (MOTOR_STEPS/LIFE_STEPS/
 * HEALTH_STEPS) without leaving the wizard.
 */
export function InsuranceTypeStep({ value, onChange, options, loading }: InsuranceTypeStepProps) {
  return (
    <div>
      <h2 className="text-lg font-semibold text-gray-900 dark:text-white">Insurance Type</h2>
      <p className="text-sm text-gray-500 dark:text-gray-400 mt-1 mb-6">
        Choose what you&rsquo;d like to get quotes for.
      </p>
      <div className="sm:max-w-xs">
        <SearchableSelect
          id="insurance_type"
          label="Insurance Type"
          options={options}
          value={value}
          onChange={onChange}
          placeholder={loading ? 'Loading...' : 'Select insurance type'}
          required
        />
      </div>
    </div>
  );
}
